import {useEffect, useState} from "react";
import "../css/WakeLockButton.css";
/*
  Backend call
 */
export default function WakeLockButton(
  {
      disabled
  } : {
      disabled: boolean;
  }
) {
    const [wakeLockSupport, setWakeLockSupport] = useState<boolean>(false);
    const [wakeLock, setWakeLock] = useState<WakeLockSentinel | null>(null);

    useEffect(() => {
        setWakeLockSupport("wakeLock" in navigator);
    }, []);

    const toggleWakeLock = () => {
        if (wakeLock == null) {
            navigator.wakeLock.request("screen").then((wakeLock) => {
                wakeLock.addEventListener("release", () => {
                    setWakeLock(null);
                });

                setWakeLock(wakeLock);
            });
        } else {
            wakeLock.release();
        }
    };


    return (
        <>
            { wakeLockSupport ?
                <div id={"wakeLock"} className={ disabled ? "disabled" : "" }>
                    <input disabled={disabled} checked={wakeLock != null} onChange={toggleWakeLock} type='checkbox' id='checkbox-1'/>
                    <label htmlFor={"checkbox-1"}>Håll skärmen tänd</label>
                </div>
                : []
            }
        </>
    );
}
